/** * 下拉过滤框组件 * data: ["cc", "dd", "cd"] */

<template>
  <div class="filterBar__container">
    <div class="filterBar__bar" @click="openMenuView()">
      <span class="selectText" :style="selectTextWidth">{{
        selectIndex === -1
          ? "未选择"
          : getOptionName(data[selectIndex])
      }}</span>
      <div class="arrowWrap">
        <span class="arrow"></span>
      </div>
    </div>
    <div
      :class="`filterBar__optionsWrap ${hide === true ? 'hide' : ''}`"
      style="z-index: 2"
    >
      <span class="arrow"></span>
      <div class="options" @scroll="handleScroll" :style="selectTextWidth">
        <div
          :class="`option ${selectIndex === -1 ? 'select' : ''}`"
          @click="handleClick(null, -1)"
          :style="selectTextWidth"
        >
          {{ "-----未选择-----" }}
        </div>
        <div
          :class="`option ${selectIndex === index ? 'select' : ''}`"
          v-for="(item, index) in data"
          :key="index"
          @click="handleClick(item, index)"
          :style="selectTextWidth"
        >
          {{ getOptionName(item) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 直播教室，课前习题列表配置组件
export default {
  name: "FilterBar",
  props: {
    data: Array,
    change: Function,
    index: {
      type: Number,
      default: 0,
    },
    optionKey: {
      type: String,
      default: "",
    },
    selectTextWidth: Object,
  },
  data() {
    return {
      selectIndex: 0,
      hide: true,
      selectKeys: [],
    };
  },
  watch: {
    index(value) {
      this.selectIndex = value;
    },
  },
  created() {},
  mounted() {
    this.selectIndex = this.index;
    if(this.optionKey){
      this.selectKeys = this.optionKey.split(",");
    }
  },
  methods: {
    getOptionName(item) {
      if(!item) return ''
      let name = "";
      if (this.selectKeys.length) {
        for (const value of this.selectKeys) {
          if (name === "") {
            name = item[value]
          } else {
            name = `${name}-${item[value]}`;
          }
        }
      } else {
        name = item;
      }
      return name;
    },
    openMenuView() {
      this.hide = !this.hide;
    },
    handleClick(item, index) {
      this.selectIndex = index;
      this.hide = true;
      this.$emit("change", item, index);
    },
    handleScroll(e) {
      var that = this;
      let height = e.target.offsetHeight;
      let scrollHeight = e.target.scrollHeight;
      let scrollTop = e.target.scrollTop;

      if (scrollHeight <= height + scrollTop + 20) {
        // console.log("到达底部");
        this.$emit("scroll");
      } else {
        // console.log("没到底部");
      }
    },
  },
};
</script>
<style scoped lang="less">
.filterBar__container {
  position: relative;
}
.filterBar__bar {
  background-color: #ecf3ff;
  border-radius: 18px;
  padding-left: 15px;
  height: 35px;
  width: calc(100% - 15px);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #999999;
  .selectText {
    line-height: 35px;
    height: 35px;
    overflow: hidden;
    margin-right: 15px;
    width: 150px;
    flex:1;
  }
  .arrowWrap {
    width: 35px;
    height: 35px;
    background-color: #5f0aff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    .arrow {
      display: inline-block;
      border: solid 5px white;
      transform: rotate(45deg);
      border-left-color: transparent;
      border-top-color: transparent;
      margin-top: -5px;
    }
  }
}

.filterBar__optionsWrap {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 5px);
  &.hide {
    display: none;
  }
  .arrow {
    display: inline-block;
    transform: rotate(45deg);

    margin-left: 30px;
    width: 10px;
    height: 10px;
    background-color: white;
    border-bottom-right-radius: 10px;
    border: 1px solid #e4e7ed;
    border-right-color: transparent;
    border-bottom-color: transparent;
  }
  .options {
    background-color: white;
    border: 1px solid #e4e7ed;
    border-radius: 5px;
    box-shadow: 0px 0px 21px 0px rgba(48, 115, 248, 0.1);
    margin-top: -11px;
    padding: 5px 0;

    max-height: 300px;
    max-width: 500px;
    min-width: 130px;
    overflow: scroll;
    .option {
      height: 35px;
      line-height: 35px;
      padding: 0 10px;
      overflow: hidden;
      color: #606266;
      font-size: 14px;
      &:hover {
        background-color: #f5f7fa;
      }
      &.select {
        color: #409eff;
      }
    }
  }
}
</style>
